<template>
    <div class="result result-video">
        <div class="row">
            <div class="col-md-12">
                <div class="result-thumbnail">
                    <a @click="watch($event)">
                        <figure>
                            <img :src="previewThumbnail" alt="">
                        </figure>
                    </a>
                </div>
                <div class="result-actions pull-right">
                    <div class="file-preview result-action" v-if="fields.url">
                        <div class="file-preview-info">
                            <a @click="watch($event)" class="action action-prevew">
                                <span
                                        class="preview-language">{{fields.lang | uppercase}}</span>
                            </a>
                        </div>
                        <div class="dropdown preview-action action-preview">
                            <button class="btn btn-flat dropdown-toggle btn-sm" data-toggle="dropdown"
                                    type="button"><i class="icon icon-locale"></i>
                                <span class="caret"></span></button>

                            <ul class="dropdown-menu">
                                <li v-for="lang in existing_languages"><a @click="watch($event,lang)"
                                                                          class="action action-download"
                                                                          target="_blank"
                                ><i :class="['icon-flag-'+lang]"
                                    class="icon icon-flag"></i><span>{{lang|uppercase}}</span></a>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="result-info">

                    <div class="result-title" v-html="fields.title">

                    </div>
                    <p class="result-description" v-html="fields.description">

                    </p>
                </div>
                <div class="file-categories">
                    <ul>
                        <li class="badge"
                            v-for="(ids,category) in fileCategories">
                            {{category}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-12">

            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "DownloadResultVideo",
        props: ['result'],
        data: function () {
            return {
                fields: null,
                id: null
            }
        },
        computed: {
            existing_languages() {
                return Array.from(this.fields.existing_languages).sort();
            },
            fileCategories() {
                let filter = this.$options.filters.category;
                let cat = {};

                let cat_id = [].concat(this.fields.level_0, this.fields.level_1, this.fields.level_2, this.fields.level_3, this.fields.level_4).filter((i) => i);
                for (let i = 0; i < cat_id.length; i++) {
                    let name = filter(cat_id[i]);

                    if (!name)
                        continue;

                    if (!cat[name]) {
                        cat[name] = [];
                    }

                    cat[name].push(cat_id[i]);
                }
                return cat;
            },
            videoID() {
                let $match = null;
                let exp = /(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/gmi;
                if ($match = exp.exec(this.fields.url)) {
                    return $match[1];
                }
                return null;
            },
            previewThumbnail() {
                return "https://i.ytimg.com/vi/" + this.videoID + "/mqdefault.jpg";
            }
        },
        methods: {
            watch(e, lang) {
                e.preventDefault();
                if (!lang) {
                    lang = this.fields.lang;
                }
                this.$emit('watch', {lang: lang, result: this.result});
                return false;
            },
            openUrl($lang, $type) {
                if (!this.result[$lang]) {
                    console.log("URL not found for Language " + $lang);
                    return '#';
                }

                if ($type !== 'preview')
                    return this.result[$lang].fields.url;

                return this.result[$lang].fields.preview_url;
            },
            mapFields() {

            }
        },
        watch: {
            result() {
                this.id = this.result.id;
                this.fields = this.result.fields;
            }
        },
        created: function () {
            console.log('Created File Result');
            this.id = this.result.id;
            this.fields = this.result.fields;

        }
    }
</script>

<style lang="less" scoped>
    .result-video {
        border-bottom: 1px solid #cfd2d1 !important;
        height: 100%;
        padding-bottom: 20px !important;
    }

    .result-actions {
        margin-top: -70px;
    }

    .result-thumbnail {
        height: auto;
        padding-bottom: 25px;

        img {
            position: absolute;
            left: 0;
            top: 0;
            min-width: 100%;
            height: auto;
            max-height: unset;
        }

        figure {
            position: relative;

            &:after {
                content: '';
                display: block;
                width: 100%;
                padding-top: 56%;
            }
        }
    }
</style>
